import { helper } from '@ember/component/helper';

// passes boolean value of the checked state for an input element
//
// Usage: {{on 'change' (input-is-checked (fn this.handleCheckedChanged))}}
//
// Before:
// @action
// handleCheckedChanged(event) { let checked = event.target.checked }

// After:
// @action
// handleCheckedChanged(checkedVal) { let checked = checkedVal }
export default helper(function ([handler]) {
  return function (e) {
    handler(e.target.checked);
  };
});
